import CohabitationDetailPage from 'cohabitation/pages/detail';
import { Outlet } from 'react-router-dom';
import {
  CohabitationAuthorizationsList,
  CohabitationAuthorizations,
} from 'shell/authorizations/cohabitation';
import { Nocp } from 'shell/utils/nocp';
import CohabitationEditPage from 'cohabitation/pages/edit';
import CohabitationInsertPage from 'cohabitation/pages/insert';
import CohabitationCancellationPage from 'cohabitation/pages/cancellation';
import CohabitationSearchPage from 'cohabitation/pages/list';
import HomePage from 'cohabitation/pages/home';
import HistorianFamilyPage from 'cohabitation/pages/historian';
import ModifyHistorianFamilyPage from 'cohabitation/pages/modify-historian';
import { NotFound } from 'shell/error/components/error-not-found';

export const cohabitationRoutes = [
  {
    path: '',
    name: 'Convivenza',
    element: <Outlet />,
    authorizations: CohabitationAuthorizationsList,
    children: [
      {
        name: 'Convivenza',
        element: <HomePage />,
        path: '/',
        hidden: true,
      },
      {
        name: 'Ricerca Convivenza',
        element: <Outlet />,
        path: '/ricerca',
        authorizations: CohabitationAuthorizationsList,
        children: [
          {
            element: <CohabitationSearchPage />,
            path: '',
            authorizations: [CohabitationAuthorizations.CohabitationQuery],
          },
          {
            element: <CohabitationDetailPage />,
            path: '/dettaglio',
            authorizations: [CohabitationAuthorizations.CohabitationQuery],
          },
          {
            element: <CohabitationEditPage />,
            authorizations: [CohabitationAuthorizations.CohabitationUpdate],
            path: '/modifica',
          },
          {
            element: <CohabitationCancellationPage />,
            authorizations: [CohabitationAuthorizations.CohabitationDelete],
            path: '/cancellazione',
          },
          {
            path: '/storico',
            name: 'Storico convivenza',
            element: <HistorianFamilyPage />,
            authorizations: [CohabitationAuthorizations.StoricoConvivenza],
          },
          {
            path: '/modifica-storico',
            name: 'Modifica Storico convivenza',
            element: <ModifyHistorianFamilyPage />,
            authorizations: [CohabitationAuthorizations.StoricoConvivenza],
          },
        ],
      },
      {
        element: <CohabitationInsertPage />,
        path: '/inserimento',
        name: 'Registrazione Convivenza',
        authorizations: [CohabitationAuthorizations.CohabitationAdd],
      },
      {
        element: <NotFound />,
        path: '*',
        hidden: true,
      },
    ],
  },
];

export const cohabitationBreadcrumbs = [
  {
    path: '/',
    name: 'Home',
    element: <Nocp />,
    children: cohabitationRoutes,
  },
];
